const ESignTetrisConfigModule = {
    namespaced: true,
    state: {
        esignConfig: null,
        configLoading: true,
    },
    actions: {
        SET_ESIGN_CONFIG({ state, commit }, esignConfig) {
            commit('SetESignConfig', esignConfig);
        },
    },
    mutations: {
        SetESignConfig: function (state, esignConfig) {
            state.esignConfig = esignConfig;
            state.configLoading = false;
        },
    },
    getters: {
        GetApproversList: function (state, getters) {
            return getters.GetLegalEntity.filter(x => x != null).map(function (x) {
                let list = []
                x.LEGAL_ENTITY_NAME.APPROVERS.forEach(function (item) {
                    list.push({
                        email: item.EMAIL,
                        name: item.NAME
                    })
                }
                )
                return list
            }).reduce(function (a, b) { return a.concat(b) })
        },
        GetESignConfig: function (state) {
            try {
                return state.esignConfig;
            } catch (err) {
                return null;
            }
        },
        ESignConfigLoaded: function (state) {

            return state.esignConfig != null
        },
        ESignConfigLoading: function (state) {
            return state.configLoading
        },
        GetApprovers: function (state, getters) {
            return (legalEntity) => {
                if (legalEntity != undefined && legalEntity != null) {
                    return getters.GetLegalEntity.filter(x => x.LEGAL_ENTITY_NAME.VALUE == legalEntity).map(x => x.LEGAL_ENTITY_NAME.APPROVERS).filter(x => x != null).reduce(function (a, b) { return a.concat(b); }, [])
                }
                else {
                    return getters.GetLegalEntity.filter(x => x != null).map(x => x.LEGAL_ENTITY_NAME.APPROVERS).filter(x => x != null).reduce(function (a, b) { return a.concat(b); }, [])
                }
            }
        },
        GetContractTypes: function (state) {
            
            return state.esignConfig.CONTRACT_TYPE
        },
        GetContractTypesByParams: function (state, getters) {
            return (counterparty, legalentity) => {
                if (counterparty == null || counterparty == undefined || legalentity == null || legalentity == undefined) {
                    return []
                }
                var list = getters.GetContractTypes;
                let counter = getters.GetCounterParties.filter(x => x.VALUE == counterparty)[0].NAME.split(" ")[0].toUpperCase();
                list = list[counter + "_CONTRACT_TYPE"]

                return list
            }
        },
        GetCounterParties: function (state) {

            return state.esignConfig.COUNTERPARTY
        },
        GetLegalEntity: function (state) {

            return state.esignConfig.LEGAL_ENTITY.LEGAL_ENTITIES
        },
        GetAreas: function (state) {

            return state.esignConfig.LEGAL_ENTITY.AREAS ? state.esignConfig.LEGAL_ENTITY.AREAS.filter(x => !x.AREA_NAME.ISDELETED).map(x => x.AREA_NAME) : []
        },
        GetPageTitle: function (state) {

            return state.esignConfig.LEGAL_ENTITY.PAGE_TITLE
        },
        GetFeesRange: function (state) {

            return state.esignConfig.FEES.FEES_FILTER
        }, 
        GetFeesRangeByCounterParty: function (state, getters) {
            return (counterParty) => {
                if (counterParty != null && counterParty != undefined) {
                    let counter = getters.GetCounterParties.filter(x => x.VALUE == counterParty)[0].NAME.split(" ")[0].toUpperCase();
                    let type = counter + "_CONTRACT_TYPE";
                    return state.esignConfig.FEES[type]
                }
                else {
                    return []
                }
            }

        },
        GetApprovalProcess: function (state) {
            return state.esignConfig.APPROVAL_PROCESS
        },
        GetLegalComplianceCounsel: function (state) {
            return state.esignConfig.LEGAL_COMPLIANCE_COUNSEL
        },
        GetSigneesA: function (state, getters) {
            return (contractType, counterParty, feesRange) => {
                if (contractType == null || contractType == undefined || counterParty == null || counterParty == undefined) {
                    return []
                }
                else {
                    let counter = getters.GetCounterParties.filter(x => x.VALUE == counterParty)[0].NAME.split(" ")[0].toUpperCase();
                    let type = counter + "_CONTRACT_TYPE";
                    let contractTypeGroup = getters.GetContractTypes[type].filter(x => x.VALUE == contractType)[0].GROUPTYPE
                    if (contractTypeGroup == 'NDA' || contractTypeGroup == 'ARO' || contractTypeGroup == 'RIT') {
                        return state.esignConfig.SIGNEES.SIGNEE_ONE[0].EMAIL_LIST.filter(function (v, i, s) {
                            return s.map(x => x.EMAIL).indexOf(v.EMAIL) == i
                        })
                    }
                    else {
                        if (feesRange == null || feesRange == undefined) {
                            return []
                        }
                        else {

                            let fees = getters.GetFeesRangeByCounterParty(counterParty).filter(x => x.VALUE == feesRange)[0]
                            
                            // Función para encontrar signees con lógica inteligente de rangos
                            const findSigneesWithSmartRangeLogic = (signeeList, targetRange) => {
                                // 1. Buscar coincidencia exacta primero
                                let exactMatch = signeeList.filter(x => 
                                    (x.MIN == null || parseInt(x.MIN) == parseInt(targetRange.MIN)) &&
                                    (x.MAX == null || parseInt(x.MAX) == parseInt(targetRange.MAX))
                                );
                                
                                if (exactMatch.length > 0) {
                                    return exactMatch;
                                }
                                
                                // 2. Si no hay coincidencia exacta, buscar rangos que cubran el rango objetivo
                                let coveringRanges = signeeList.filter(x => {
                                    let xMin = x.MIN == null ? 0 : parseInt(x.MIN);
                                    let xMax = x.MAX == null ? Infinity : parseInt(x.MAX);
                                    let targetMin = targetRange.MIN == null ? 0 : parseInt(targetRange.MIN);
                                    let targetMax = targetRange.MAX == null ? Infinity : parseInt(targetRange.MAX);
                                    
                                    // El rango del signee debe solaparse con el rango objetivo
                                    return xMin < targetMax && xMax > targetMin;
                                });
                                
                                // 3. Si tenemos rangos que cubren, intentar combinar para cubrir completamente
                                if (coveringRanges.length > 0) {
                                    // Ordenar por MIN para procesamiento secuencial
                                    coveringRanges.sort((a, b) => {
                                        let aMin = a.MIN == null ? 0 : parseInt(a.MIN);
                                        let bMin = b.MIN == null ? 0 : parseInt(b.MIN);
                                        return aMin - bMin;
                                    });
                                    
                                    return coveringRanges;
                                }
                                
                                // 4. Fallback: usar todos los signees disponibles
                                return signeeList;
                            };

                            let filteredSignees = findSigneesWithSmartRangeLogic(state.esignConfig.SIGNEES.SIGNEE_ONE, fees);
                            
                            return filteredSignees
                                .map(x => x.EMAIL_LIST).reduce(function (a, b) { return a.concat(b); }, []).filter(function (v, i, s) {
                                    return s.map(x => x.EMAIL).indexOf(v.EMAIL) == i
                                })
                        }
                    }
                }
            }
        },
        GetSigneesB: function (state, getters) {
            return (contractType, counterParty, feesRange) => {
                if (contractType == null || contractType == undefined || counterParty == null || counterParty == undefined) {
                    return []
                }
                else {
                    let counter = getters.GetCounterParties.filter(x => x.VALUE == counterParty)[0].NAME.split(" ")[0].toUpperCase();
                    let type = counter + "_CONTRACT_TYPE";
                    let contractTypeGroup = getters.GetContractTypes[type].filter(x => x.VALUE == contractType)[0].GROUPTYPE
                    if (contractTypeGroup == 'ARO') {
                        return state.esignConfig.SIGNEES.SIGNEE_ONE[0].EMAIL_LIST
                    }
                    else {
                        if (feesRange == null || feesRange == undefined) {
                            return []
                        }
                        else {

                            let counter = getters.GetCounterParties.filter(x => x.VALUE == counterParty)[0].NAME.split(" ")[0].toUpperCase();
                            let fees = getters.GetFeesRangeByCounterParty(counterParty).filter(x => x.VALUE == feesRange)[0]

                            // Función para encontrar signees con lógica inteligente de rangos
                            const findSigneesWithSmartRangeLogic = (signeeList, targetRange) => {
                                // 1. Buscar coincidencia exacta primero
                                let exactMatch = signeeList.filter(x => 
                                    (x.MIN == null || parseInt(x.MIN) == parseInt(targetRange.MIN)) &&
                                    (x.MAX == null || parseInt(x.MAX) == parseInt(targetRange.MAX))
                                );
                                
                                if (exactMatch.length > 0) {
                                    return exactMatch;
                                }
                                
                                // 2. Si no hay coincidencia exacta, buscar rangos que cubran el rango objetivo
                                let coveringRanges = signeeList.filter(x => {
                                    let xMin = x.MIN == null ? 0 : parseInt(x.MIN);
                                    let xMax = x.MAX == null ? Infinity : parseInt(x.MAX);
                                    let targetMin = targetRange.MIN == null ? 0 : parseInt(targetRange.MIN);
                                    let targetMax = targetRange.MAX == null ? Infinity : parseInt(targetRange.MAX);
                                    
                                    // El rango del signee debe solaparse con el rango objetivo
                                    return xMin < targetMax && xMax > targetMin;
                                });
                                
                                // 3. Si tenemos rangos que cubren, intentar combinar para cubrir completamente
                                if (coveringRanges.length > 0) {
                                    // Ordenar por MIN para procesamiento secuencial
                                    coveringRanges.sort((a, b) => {
                                        let aMin = a.MIN == null ? 0 : parseInt(a.MIN);
                                        let bMin = b.MIN == null ? 0 : parseInt(b.MIN);
                                        return aMin - bMin;
                                    });
                                    
                                    return coveringRanges;
                                }
                                
                                // 4. Fallback: usar todos los signees disponibles
                                return signeeList;
                            };

                            let filteredSignees = findSigneesWithSmartRangeLogic(state.esignConfig.SIGNEES.SIGNEE_TWO, fees);
                            
                            return filteredSignees
                                .map(x => x.EMAIL_LIST).reduce(function (a, b) { return a.concat(b); }, []).filter(function (v, i, s) {
                                    return s.map(x => x.EMAIL).indexOf(v.EMAIL) == i
                                })
                        }
                    }
                }
            }
        },
        GetLiabilityCapOptions: function (state) {
            return state.esignConfig.LIABILITY_CAP_OPTIONS
        },
        GetDueDiligence: function (state, getters) {
            return (counterParty) => {
                if (counterParty != null && counterParty != undefined) {
                    let counter = getters.GetCounterParties.filter(x => x.VALUE == counterParty)[0].NAME.split(" ")[0].toUpperCase();
                    return state.esignConfig.DUE_DILIGENCE[counter]
                }
                else return {
                    BODY: "",
                    CHECKS: [],
                    OPTIONS: [],
                    TITLE: ""
                }
            }
        }




    },
};
export default ESignTetrisConfigModule;